import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {UserModel} from '../models/user.model';
import {getActionsHistoryUrl, getHistoryUrl, getPublicationUrl, getReportsHistoryUrl} from '../app.urls';



@Injectable()
export class HistoryService {
    constructor(private http: HttpClient) {
    }

    getHistory(query?: any) {
        return this.http.get(getHistoryUrl(), {params: query});
    }
    getReportsHistory(query?: any) {
        return this.http.get(getReportsHistoryUrl(), {params: query});
    }
    getActionHistory(query?: any) {

        return this.http.get(getActionsHistoryUrl(), {params: query});
    }
      getHistoryForPublication(id:number) {
        return this.http.get(getHistoryUrl()+'/'+id, );
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/history.service.ts